import React, { useContext, useState } from "react";
import { IconButton } from "@mui/material";
import { FiPlus, FiUploadCloud } from "react-icons/fi";
import CustomerListItem from "./components/CustomerListItem";

import { PagedDataView } from "../../components/lists/PagedDataView/PagedDataView";
import ErrorDialog from "../../components/notifications/errorDialog/ErrorDialog";
import { ProgressDialog } from "../../components/notifications/progressDialog/progressDialog";
import { api, IListCustomerItem, IListCustomers } from "../../logic/api";
import { SessionContext } from "../../utility/useSession";
import CreateCustomerDialog from "./CreateCustomerDialog";
import CustomerEditorDialog from "./components/CustomerEditorDialog";
import { useTranslation } from "react-i18next";
import flex from "../../styles/flex";
import ConfirmationDialog from "../../components/notifications/confirmationDialog/ConfirmationDialog";


const CustomerManager = () => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();

  const [listCustomerParams, setListCustomerParams] = useState<IListCustomers>(
    {}
  );

  const [currentCustomer, setCurrentCustomer] = useState<IListCustomerItem | null>(null);

  const [showCreateCustomerDialog, setShowCreateCustomerDialog] = useState(
    false
  );

  const [showEditCustomerDialog, setShowEditCustomerDialog] = useState(
    false
  );

  const [showUpdateDialog, setShowUpdateDialog] = useState(false);

  const deleteCustomerAPI = api.hooks.admin.deleteCustomer();

  const applyUpdateAPI = api.hooks.admin.recreateReportsCustomerCarParksTable();

  const deleteCustomer = async (customer: IListCustomerItem) => {
    const accessKey = prompt(t("admin.enterDevAccessKey"));
    if (accessKey == null) {
      alert(t("admin.mustProvideDevAccessKey"));
      return;
    }
    const conf = prompt(t("admin.dataLossWarning"));
    if (conf != customer.database) {
      alert(t("admin.databaseNameMismatch"));
      return;
    }
    deleteCustomerAPI.send(
      session.current.context,
      {
        database: customer.database,
        accessKey: accessKey,
        drop: true,
      },
      (result) => {
        if (result != null) {
          setListCustomerParams({});
        }
      }
    );
  };

  return (
    <div>

      <CreateCustomerDialog
        show={showCreateCustomerDialog}
        onClose={(updated) => {
          setShowCreateCustomerDialog(false);
          if (updated == true) {
            setListCustomerParams({});
          }
        }}
      ></CreateCustomerDialog>

      {currentCustomer != null && (
        <CustomerEditorDialog
          show={showEditCustomerDialog}
          customer={currentCustomer}
          onClose={(updated) => {
            setShowEditCustomerDialog(false);
            if (updated == true) {
              setListCustomerParams({});
            }
          }}
        ></CustomerEditorDialog>
      )}

      <ConfirmationDialog
        title="Recreate Customer CarParks Table"
        message="This will update the list of customers and carparks in the reports system. Are you sure you want to recreate the Customer CarParks Table for Reports V2?"

        show={showUpdateDialog}
        onClose={(confirmed) => {
          setShowUpdateDialog(false);
          if (confirmed) {
            applyUpdateAPI.send(session.current.context, {}, (result) => {
              if (result != null) {
                setListCustomerParams({});
              }
            });
          }
        }}
      ></ConfirmationDialog>

      <ProgressDialog status={deleteCustomerAPI.status}></ProgressDialog>
      <ErrorDialog err={deleteCustomerAPI.err}></ErrorDialog>

      <ProgressDialog status={applyUpdateAPI.status}></ProgressDialog>
      <ErrorDialog err={applyUpdateAPI.err}></ErrorDialog>

      <div style={{ ...flex.flexRows, marginBottom: 20 }}>
        <div style={flex.flexFill}>
          <IconButton
            color="secondary"
            title={"Recreate Customer CarParks Table for Reports V2"}
            onClick={() => {
              setShowUpdateDialog(true);
            }}
          >
            <FiUploadCloud />
          </IconButton>

        </div>
        <div style={flex.flexAuto}>
          <IconButton
            title="New Customers"
            onClick={() => {
              setShowCreateCustomerDialog(true);
            }}
          >
            <FiPlus />
          </IconButton>
        </div>
      </div>
      <div style={{ minHeight: 300 }}>
        <PagedDataView<IListCustomers, IListCustomerItem>
          apiHook={api.hooks.admin.listCustomers}
          parameters={listCustomerParams}
          renderItem={(item) => {
            return (
              <CustomerListItem
                customer={item}
                onClick={() => {
                  console.log(item);
                }}
                onDelete={() => {
                  deleteCustomer(item);
                }}
                onEdit={() => {
                  setShowEditCustomerDialog(true);
                  setCurrentCustomer(item);
                }}
              ></CustomerListItem>
            );
          }}
        >
          <div style={{ padding: 20, backgroundColor: "#eee" }}>
            {t("admin.noCustomers")}
          </div>
        </PagedDataView>
      </div>
    </div >
  );
}

export default CustomerManager;
